<template>
<div @click="handleOpen()" v-in-viewport :class="['column  is-paddingless ' + checkMaxHeight,  'is-offset-0 is-12 ']">
  <!-- <div @click="handleOpen()" :class="['column expandable is-paddingless ' + checkMaxHeight, open ? 'is-offset-0 is-12 ' : checkOffset + ' is-half-mobile is-one-third-fullhd is-half-tablet']"> -->
  <!-- {{ this.src }} -->
  <slot></slot>
  <div v-if="border" class="lookbook-bg-border" :style="'border-image: url(' + getBorder() + ') ' + borderSlice + ' ' + borderSlice + ' repeat; '">

  </div>
  <div ref="lookbookEl" class="lookbook-bg-container ">
    <div class="ani-bg-opacity lookbook-bg" :style="'background-color: #' + this.color ">

    </div>

    <div class="lb-position ani-bg-opacity position-left" :style=" open && bgOffset < 50 ? 'opacity: 0' : ''">
      <img :src="this.source('left')"></img>
      <!-- <lazyImage :lazySrc="this.source('left')"></lazyImage> -->
    </div>
    <div class="lb-position ani-bg-opacity position-center ">
      <div :class="['position-center-wrapper ', offsetCenterImage] ">

        <lazyImage :lazySrc="this.source('center')"></lazyImage>
      </div>
    </div>
    <div class="lb-position ani-bg-opacity position-right" :style=" open && bgOffset > 50 ? 'opacity: 0' : ''">
      <img :src="this.source('right')"></img>
      <!-- <lazyImage :lazySrc="this.source('right')"></lazyImage> -->
    </div>
    <lazyImage class="proportions-helper" :lazySrc="placeholder" :width="1134" :height="1605"></lazyImage>
    <!-- <div class="lookbook-bg-container" :style="bgCenter">
      <div class="lookbook-bg-container" :style="bgRight">
        <div class="lookbook-bg-container" :style="bgLeft">
          <lazyImage class="proportions-helper" :lazySrc="placeholder" :width="1134" :height="1605"></lazyImage> -->
    <transition name="router-transition" mode="out-in">
      <div :class="['lookbook-info', bgOffset < 50 ? ' right' : '']" v-show="open">

        <div class="">

          <p>{{title}}</p>
          <p>{{price}}</p>
          <a :href="link" target="_blank" class="styled-button">Buy Now</a>
          <!-- <p class="lookbook-hasBackside" v-if="hasBackside && link2 == ''" @mouseover="hovered = true" @mouseleave="hovered = false">View Backside</p> -->


          <p style="padding-top: 4rem" v-if="link2 != ''">{{title2}}</p>
          <p v-if="link2 != ''">{{price2}}</p>
          <a v-if="link2 != ''" :href="link2" target="_blank" class="styled-button">Buy Now</a>
          <!-- <p class="lookbook-hasBackside" v-if="hasBackside && link2 != ''" @mouseover="hovered = true" @mouseleave="hovered = false">View Backside</p> -->

        </div>
      </div>
    </transition>
    <!-- </div>
      </div>
    </div> -->
  </div>
</div>
</template>

<script>
import lazyImage from '@/components/layout/_lazyImage.vue';

export default {
  name: 'columnWithOffsetBg',
  data() {
    return {
      open: false,
      hovered: false,
      preloaded: false
    }
  },
  components: {
    lazyImage
  },
  computed: {
    offsetCenterImage() {
      if (!this.open) {
        return ''
      }
      if (this.bgOffset >= 50) {
        return 'move-right'
      } else {
        return 'move-left'
      }
    },
    backgroundStyles() {
      let centerSide = this.hasBackside && this.hovered ? 'center_back' : 'center';
      let center = ' url(' + this.source(centerSide) + ') ' + this.bgOffset + '% bottom';
      let right = 'url(' + this.source('right') + ') right bottom';
      let left = ' url(' + this.source('left') + ') left bottom';

      return 'background: ' + left + ',' + right + ',' + center + ';  background-color: #' + this.color
      // return 'background: url(' + this.source('center') + ') ' + this.bgOffset + '% bottom, url(' + this.source('right') + ') right bottom,  url(' + this.source('left') + ') left bottom;  background-color: #' + this.color
    },
    bgLeft() {
      return 'background:  url(' + this.source('left') + ') left bottom'
    },
    bgRight() {
      return 'background: url(' + this.source('right') + ') right bottom'
    },
    bgCenter() {
      let centerSide = this.hasBackside && this.hovered ? 'center_back' : 'center';
      return 'background:  url(' + this.source(centerSide) + ') ' + 50 + '% bottom'
    },
    // checkWidth() {
    //   return this.width == 'auto' ? '' : ' is-' + this.width
    // },
    checkOffset() {
      let isMobile = this.$root.isMobile;
      let offset = isMobile ? Math.round(this.offset / 2 + 1) : this.offset
      return this.offset == '0' ? '' : ' is-offset-' + offset
    },
    checkMargin() {
      return this.margin == '0' ? '' : 'margin-top: ' + this.margin + '%;'
    },
    checkMaxHeight() {
      return this.maxHeight == true ? ' max-height' : ''
    },
    checkWidth() {
      let isMobile = this.$root.isMobile;
      let defaultWidth = 4;
      return isMobile ? ' is-half-mobile' : ' is-one-third-fullhd'
    },
    placeholder() {
      return require('@/assets/images/lblayers/proportions.png')
    },
  },
  mounted() {

  },
  methods: {

    preloadImages(srcs, imgs) {
      var img;
      var self = this;
      var remaining = srcs.length;
      for (var i = 0; i < srcs.length; i++) {
        img = new Image();
        img.onload = function() {
          --remaining;
          if (remaining <= 0) {
            // callback();
            self.preloaded = true;
          }
        };
        img.src = srcs[i];
        //  imgs.push(img);
      }
    },
    handleOpen() {
      if (!this.preloaded && this.hasBackside) {
        this.preloadImages(['http://localhost:8080' + this.source('center_back')])
      }
      this.open = !this.open
      if (this.open) {
        this.$refs.lookbookEl.scrollIntoView({
          block: "center",
          behavior: "smooth"
        });
      }
    },
    source(align) {
      return require('@/assets/images/lblayers/lookbook_' + this.src + '_' + align + '.png')
    },
    getBorder() {
      return require('@/assets/images/lblayers/lookbook_' + this.src + '_' + 'border.png')
    },

  },

  props: {
    width: {
      type: String,
      default: 'auto'
    },
    maxHeight: {
      type: Boolean,
      default: true
    },
    hasBackside: {
      type: Boolean,
      default: false
    },
    offset: {
      type: String,
      default: '0'
    },
    bgOffset: {
      type: String,
      default: '80'
    },
    margin: {
      type: String,
      default: '0'
    },

    src: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    border: {
      type: Boolean,
      default: false
    },
    borderSlice: {
      type: String,
      default: '199'
    },
    title: {
      type: String,
      default: ''
    },
    price: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    title2: {
      type: String,
      default: ''
    },
    price2: {
      type: String,
      default: ''
    },

    link2: {
      type: String,
      default: ''
    },
  }
}
</script>

<style lang="scss" scoped>
.lookbook-bg-border {
    height: calc(100% - 15vw /2);
    width: 100%;
    border: 15vw solid transparent;
    position: absolute;
    z-index: 1;
    pointer-events: none;
}
.lookbook-bg {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
}

.proportions-helper {
    opacity: 0;
    pointer-events: none;
}
.lookbook-info {
    width: 75vw;
    position: absolute;
    height: 100%;
    top: 0;
    div {
        text-align: center;
        font-size: 2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        // .buy-now {
        //     border-radius: 2rem;
        //     margin: 1em;
        //
        //     filter: drop-shadow(0px 0px 3px red) drop-shadow(0px 0px 7px black);
        //     padding: 0 1em 5px;
        //     cursor: pointer;
        //     border: 2px $red solid;
        //     color: $red;
        // }
    }
    &.right {
        // float: right;
        // right: 0;

    }
}

.max-height {
    position: relative;
    overflow: hidden;
    img {
        max-height: 100vh;
        // height: 100%;
    }
}
.lb-position {
    align-items: flex-end;
    display: flex;
    position: absolute;
    bottom: 0;
    transition: transform 1s cubic-bezier(0.075, 0.82, 0.165, 1), opacity 0.5s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
    will-change: transform, opacity;
}
.position-left {
    left: 0;
    transform: translateX(-100%);

}
.position-right {
    right: 0;
    transform: translateX(100%);

}
.position-center-wrapper {
    transition: transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955);
    transform: translateX(0%);
    will-change: transform;
    &.move-right {
        transform: translateX(calc(70% - 50vh / 2));
    }
    &.move-left {
        transform: translateX(calc(20% - 50vh / 2));
    }

}
.position-center {
    width: 100%;
    // right: 0;

}
.ani-bg-opacity {
    transition: opacity 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);
    will-change: opacity;
    opacity: 0;
    // background-color: black;

}

.in-viewport {
    .ani-bg-opacity {
        opacity: 1;
        // background-color: ;
    }

    .position-left,
    .position-right {
        transform: translateX(0%);
    }
}
.expandable {
    transition: width 1s cubic-bezier(0.645, 0.045, 0.355, 1), margin 1s cubic-bezier(0.645, 0.045, 0.355, 1);
    backface-visibility: hidden;
    transform: translateZ(0);
    will-change: margin, width;
    img {
        transform: translateZ(0);
        will-change: max-height;
    }
}

@keyframes move {
    from {
        width: 0;
    }
    to {
        width: 100%;
    }
}
@media screen and (max-width: 600px) {
    .lookbook-info {
        div:not(.buy-now) {
            text-align: left;
            text-shadow: 1px 2px 3px black;
            position: absolute;
            bottom: 2rem;
            left: 0;
            transform: none;
            top: auto;
            .styled-button {
                background: black !important;
            }
            p:not(.buy-now) {
                margin: 0 2rem;
            }
        }
        &.right {
            float: right;
            text-align: right;
            right: 0;
            div {
                float: right;
                text-align: right;
                right: 0;
            }
        }
    }
}
</style>
